import { reactive } from 'vue'

// 全局加载状态类型
export interface GlobalLoadingState {
  global: boolean
}

// 全局加载状态
const globalLoadingState = reactive<GlobalLoadingState>({
  global: true
})

export function useGlobalLoading() {
  const show = () => {
    globalLoadingState.global = true
  }
  const hide = () => {
    globalLoadingState.global = false
  }

  return {
    // 状态
    loadingState: globalLoadingState,

    // 方法
    show,
    hide
  }
}
